export default "/images/vendor/flag-icon-css/flags/4x3/va.svg?cf6a492acafefcbefa109e46322d5e8d";